import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import LoadingOverlay from "react-loading-overlay-ts";
import { useDispatch, useSelector } from "react-redux";
import { useHistory } from "react-router";

import { authApi, merchantApi } from "@api";
import { ComponentPopUpTerms, SharedInput, StyledError } from "@components";
import {
    DAYS,
    MONTHS,
    PATH_HOME,
    YEARS,
    enumExternalMethod,
    enumStatus,
    enumValidateKey,
    genderOptions,
} from "@configs";
import {
    IAddressData,
    IAmphur,
    IDate,
    IProvince,
    ISelect,
    ISubDistrict,
    ISurveyQuestions,
} from "@interfaces";
import {
    getInfo,
    selectAuth,
    selectMerchant,
    setCouponId,
    setExternalLogin,
    setFreePointId,
    setFromLogin,
    setFromSignup,
    setInviteId,
    setLoading,
    setMemberTypeDetail,
    store,
} from "@redux";
import { formatMessage, useNotify, validNationalID } from "@utils";
import { Button, Checkbox, Col, Flex, Radio, Row, Select, Skeleton } from "antd";
import DynamicDropdown from "src/Components/shared/DynamicDropdown";
import LoadOverlay from "src/Components/shared/LoadOverlay";
import styled from "styled-components";
const { Option } = Select;

interface IProps {
    // handleChangeTerm: (e: boolean) => void;
    // showTerm: boolean;
    // isConfirm: boolean;
    showPreType: boolean;
}

interface IAns {
    fullName: string;
    fName: string;
    lName: string;
    email: string;
    gender: string;
    dateOfBirth: string;
    address: string;
    id_card: string;
    companyName: string;
    studentID: string;
    staffID: string;
    channelStore: string;
    acceptTermsAndConditions: boolean;
    nationalID: string;
    staffArea?: string;
}

const INIT_ANS: IAns = {
    fullName: "",
    fName: "",
    lName: "",
    email: "",
    gender: "",
    dateOfBirth: "",
    address: "",
    id_card: "",
    companyName: "",
    studentID: "",
    staffID: "",
    channelStore: "",
    acceptTermsAndConditions: false,
    nationalID: "",
    staffArea: "",
};

const INIT_ADDRESS: IAddressData = {
    address: "",
    district: "",
    province: "",
    subDistrict: "",
    postCode: "",
};

export const ModulePreType = (props: IProps) => {
    //props
    const { showPreType } = props;
    const dispatch = useDispatch();
    const history = useHistory();
    const { themes } = useSelector(selectMerchant);
    const merchant = useSelector(selectMerchant);
    const { t } = useTranslation();
    const { success, warning, error } = useNotify();
    const [groupList, setGroupList] = useState<any[]>([]);
    const [onSelect, setOnSelect] = useState<any>({
        groupIndex: "",
        typeIndex: "",
    });
    const [type, setType] = useState("");
    const [step, setStep] = useState<number>(1);
    const [focusType, setFocusType] = useState<any>();
    const [ans, setAns] = useState<IAns>(INIT_ANS);

    const [date, setDate] = useState<IDate>({
        day: "",
        month: "",
        year: "",
        error: "",
    });
    const [addressData, setAddressData] = useState<IAddressData>(INIT_ADDRESS);
    const [provinceList, setProvinceList] = useState<IProvince[]>([]);
    const [amphurList, setAmphurList] = useState<IAmphur[]>([]);
    const [subDistrictList, setSubDistrictList] = useState<ISubDistrict[]>([]);
    const [customField, setCustomField] = useState<any[]>([]);
    const { userInfo } = useSelector(selectAuth);
    const [isLoading, setIsloading] = useState(true);
    const [isLoaderActive, setIsLoaderActive] = useState<boolean>(false);

    const [isTerm, setIsTerm] = useState<boolean>(false);
    const [formCompleted, setFormCompleted] = useState(false);

    const { terms } = useSelector(selectAuth);

    const [isFullName, setIsFullName] = useState();

    const [validateKey, setValidateKey] = useState<string>("");

    const getValidateKey = async () => {
        try {
            const res = await authApi.getValidateKey({
                useIn: "SIGN_UP",
            });

            setValidateKey(res.data.result);
        } catch (err: any) {
            console.log(formatMessage(err.response));
            // error(formatMessage(err.response));
        }
    };

    useEffect(() => {
        getValidateKey();
    }, []);

    const checkValidateKey = async () => {
        if (validateKey === enumValidateKey.EMAIL) {
            const regex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
            if (!regex.test(ans.email)) {
                warning("Invalid email format");
                return;
            }
        }
        const value =
            validateKey === enumValidateKey.EMAIL
                ? ans.email
                : validateKey === enumValidateKey.NATIONAL_ID
                ? ans.nationalID
                : validateKey === enumValidateKey.STAFF_ID
                ? ans.staffID
                : validateKey === enumValidateKey.STUDENT_ID
                ? ans.studentID
                : "";

        try {
            const res = await authApi.getValidateKeyValue({
                useIn: "SIGN_UP",
                validateKey: validateKey,
                value: value,
            });
            if (res.data.result) {
                const result = res.data.result;
                // ansList[e.target.name] = e.target.value;

                setAns({
                    ...ans,
                    ...(result.FULLNAME && isFullName && { fullName: result.FULLNAME }),
                    ...(result.FIRSTNAME && !isFullName && { fName: result.FIRSTNAME }),
                    ...(result.LASTNAME && !isFullName && { lName: result.LASTNAME }),
                    ...(result.CHANNEL_STORE && { channelStore: result.CHANNEL_STORE }),
                    ...(result.COMPANY_NAME && { companyName: result.COMPANY_NAME }),
                    ...(result.GENDER && { gender: result.GENDER.toLocaleUpperCase() }),
                    ...(result.NATIONAL_ID && { nationalID: result.NATIONAL_ID }),
                    ...(result.STAFF_ID && { staffID: result.STAFF_ID }),
                    ...(result.STUDENT_ID && { studentID: result.STUDENT_ID }),
                    ...(result.EMAIL && { email: result.EMAIL }),
                    ...(result.STAFF_AREA && { staffArea: result.STAFF_AREA }),
                });
                setDate({
                    day: result.BIRTHDATE?.slice(8, 10),
                    month: result.BIRTHDATE?.slice(5, 7),
                    year: result.BIRTHDATE?.slice(0, 4),
                });
                console.log(
                    "day month year",
                    result.BIRTHDATE?.slice(8, 10),
                    result.BIRTHDATE?.slice(5, 7),
                    result.BIRTHDATE?.slice(0, 4)
                );
            }
            if (res.data.message) {
                success(formatMessage(res));
            }
        } catch (err: any) {
            error(formatMessage(err.response));
        }
    };

    const getIsFullName = async () => {
        try {
            const res = await merchantApi.getIsFullName();
            if (res.data) {
                setIsFullName(res.data.isFullName);
            }
        } catch (err) {
            console.log(err);
        }
    };

    useEffect(() => {
        getIsFullName();
    }, []);

    useEffect(() => {
        if (showPreType) {
            fetchMemberType();
            getAllProvince();
        }
    }, [showPreType]);

    // useEffect(() => {
    //     setIsloading(true);
    //     if (groupList) {
    //         setIsloading(false);
    //     }
    // });

    const getAllProvince = async () => {
        let allRes = await merchantApi.getAllProvince();
        setProvinceList(allRes.data.result);
    };
    const getAmphur = async (pId: number) => {
        let allAmphur = await merchantApi.getAmphur({
            province_id: pId,
            xpage: 1,
            xlimit: 100,
        });
        setAmphurList(allAmphur.data.result);
        let newAdd = addressData;
        newAdd.province = pId.toString();
        newAdd.district = "";
        newAdd.subDistrict = "";
        newAdd.postCode = "";
        setAddressData(newAdd);
    };
    const getSubDistrictByamphur = async (aId: number) => {
        let subRes = await merchantApi.getSubDistrict({
            amphur_id: aId,
            xpage: 1,
            xlimit: 100,
        });
        setSubDistrictList(subRes.data.result);
        let newAdd = addressData;
        newAdd.province = subRes.data.result[0].province_id;
        newAdd.district = aId.toString();
        newAdd.subDistrict = "";
        newAdd.postCode = "";
        setAddressData(newAdd);
    };
    const onChangeProvince = async (value: any) => {
        setAddressData({
            ...addressData,
            province: value,
        });
        await getAmphur(value);
    };
    const onChangeAmphur = async (value: any) => {
        setAddressData({
            ...addressData,
            district: value,
        });
        await getSubDistrictByamphur(value);
    };
    const onChangeSubDistrict = (value: any) => {
        let outSub = Object.values(subDistrictList).find((item) => item.district_id === value);
        setAddressData({
            ...addressData,
            // subDistrict: outSub?.district_id,
            subDistrict: value,
            postCode: outSub?.zipcode || "",
        });
    };
    const setAddressText = (value: any, name: string) => {
        let newAdd = {
            ...addressData,
            [name]: value,
        };
        setAddressData({
            ...newAdd,
        });
    };

    const fetchMemberType = async () => {
        let res = await authApi.getMemberTypeConfig();
        setGroupList(res.data);
        setIsloading(false);
    };

    const onSelecting = (gIndex: number, tIndex: number) => {
        setOnSelect({
            groupIndex: gIndex,
            typeIndex: tIndex,
        });
    };

    const staticQuestion = merchant.signUpSettings?.staticQuestion;

    useEffect(() => {
        const handlePopState = (event: PopStateEvent) => {
            if (!formCompleted) {
                event.preventDefault();
                alert("You have unsaved changes. Please complete the form before leaving.");
            }
        };

        const handleBeforeUnload = (event: BeforeUnloadEvent) => {
            if (!formCompleted) {
                const message = "You have unsaved changes. Are you sure you want to leave?";
                event.returnValue = message;
                return message;
            }
        };

        window.addEventListener("popstate", handlePopState);
        window.addEventListener("beforeunload", handleBeforeUnload);

        return () => {
            window.removeEventListener("popstate", handlePopState);
            window.removeEventListener("beforeunload", handleBeforeUnload);
            // if (!formCompleted) {
            //     localStorage.clear();
            //     window.location.reload();
            // }
        };
    }, [formCompleted]);

    const step1Next = async () => {
        if (
            userInfo?.status === enumStatus.ACTIVE &&
            userInfo?.contact?.memberTypeGroupNameId === undefined
        ) {
            //
            let payload = {
                memberTypeGroupNameId: groupList[onSelect.groupIndex]?._id,
                memberTypeNameId:
                    groupList[onSelect?.groupIndex]?.typeGroupNameList[onSelect?.typeIndex]?._id,
            };
            await authApi.saveQuestionSignUp(payload);
            success(t("message.sign_up.success"));
            dispatch(setExternalLogin({ type: enumExternalMethod.TEL, isSignUp: false }));
            history.push(PATH_HOME);
            await dispatch(getInfo());
            dispatch(setFromLogin(true));
        } else if (onSelect?.groupIndex !== "" && onSelect?.typeIndex !== "") {
            setFocusType(groupList[onSelect?.groupIndex]?.typeGroupNameList[onSelect?.typeIndex]);
            let payload = {
                gId: groupList[onSelect.groupIndex]?._id,
                tId: groupList[onSelect?.groupIndex]?.typeGroupNameList[onSelect?.typeIndex]?._id,
            };
            let res = await authApi.getMemberTypeField(payload);
            let custom: any = [];
            res.data?.forEach((fItem: any) => {
                let obj = {
                    answer: [],
                    freeTextAnswer: "",
                    isRequired: fItem?.isRequired,
                    propertyName: fItem?.propertyName,
                    question: fItem?.fieldName,
                    questionId: fItem?._id,
                    isFreeTextAnswer: fItem?.isFreeTextAnswer,
                    multiple: fItem?.multiple,
                    options: fItem?.options,
                };
                custom.push(obj);
            });
            setCustomField(custom);
            setStep(2);
            window.scrollTo(0, 0);
        } else {
            warning(t("message.please_select_type"));
        }
    };

    const step2Next = async () => {
        await null;
        try {
            setIsLoaderActive(true);
            let check = false;
            let msg = "";
            const dateForm =
                date.month && date.day && date.year
                    ? new Date(date.month + "/" + date.day + "/" + date.year)
                    : null;

            let outAnsList: ISurveyQuestions[] = [];
            customField.forEach((fItem: any) => {
                let checkEmpty = true;
                if (fItem?.isRequired) {
                    if (fItem?.isFreeTextAnswer) {
                        if (fItem?.answer === "" || fItem?.answer?.length === 0) {
                            checkEmpty = false;
                            check = true;
                            msg = t("message.field_validate_empty") + fItem?.question;
                        }
                    } else {
                        if (fItem?.answer?.length === 0) {
                            checkEmpty = false;
                            check = true;
                            msg = t("message.field_validate_empty") + fItem?.question;
                        }
                    }
                } else {
                    if (fItem?.isFreeTextAnswer) {
                        if (fItem?.answer === "" || fItem?.answer?.length === 0) {
                            checkEmpty = false;
                        }
                    } else {
                        if (fItem?.answer?.length === 0) {
                            checkEmpty = false;
                        }
                    }
                }
                if (checkEmpty) {
                    let outObj = {
                        answers: fItem?.isFreeTextAnswer ? [] : fItem.answer,
                        freeTextAnswer: fItem?.isFreeTextAnswer ? fItem.answer : "",
                        isRequired: fItem?.isRequired,
                        propertyName: fItem?.propertyName,
                        question: fItem?.question,
                        questionId: fItem?.questionId,
                    };
                    outAnsList.push(outObj);
                }
            });

            // if (ans.fullName === "") {
            //     warning("Please fill data");
            //     return;
            // }
            let outSubdisIndex = 0;
            if (addressData?.subDistrict !== "") {
                outSubdisIndex = parseInt(addressData.subDistrict);
            }
            let proObj = provinceList.find((item) => item?.province_id === addressData?.province);
            let disObj = amphurList.find((item) => item?.amphur_id === addressData.district);
            // let subObj = subDistrictList[parseInt(addressData?.subDistrict)];
            let subObj = subDistrictList.find(
                (item) => item?.district_id === addressData?.subDistrict
            );
            let fullAdd = [
                addressData?.address,
                proObj?.province_name_tha,
                disObj?.amphur_name_tha,
                subObj?.district_name_tha,
                addressData.postCode,
            ].join(" ");

            let inviteCode = store.getState().page.inviteId;
            let sellerCode = store.getState().page.sellerId;
            let couponId = store.getState().page.couponId;
            let freepointId = store.getState().page.freepointId;
            if (!ans.acceptTermsAndConditions) {
                check = true;
                msg = "please accept terms & conditions";
            }
            focusType?.typeNameSignForm?.forEach((fItem: any) => {
                if (fItem?.name === "id_card" && fItem?.isActive && ans.id_card) {
                    if (!validNationalID(ans.id_card)) {
                        check = true;
                        msg = "Card ID is incorrect.";
                    }
                }
                if (fItem?.name === "id_card" && fItem?.isRequired && fItem?.isActive) {
                    if (!ans.id_card) {
                        check = true;
                        msg =
                            t("message.field_validate_empty") +
                            t("page.pretype." + t("page.cardId"));
                    } else if (!validNationalID(ans.id_card)) {
                        check = true;
                        msg = "Card ID is incorrect.";
                    }
                } else if (fItem?.name === "dateOfBirth" && fItem?.isRequired) {
                    if (dateForm === null) {
                        check = true;
                        msg = t("message.field_validate_empty") + t("page.pretype." + fItem?.name);
                    }
                } else if (
                    fItem?.name === "address" &&
                    merchant?.signUpSettings?.staticQuestion?.address?.isRequired &&
                    !merchant?.signUpSettings?.staticQuestion?.address?.isRedeem
                ) {
                    if (
                        addressData?.address === "" ||
                        addressData?.district === "" ||
                        addressData?.province === "" ||
                        addressData?.subDistrict === "" ||
                        addressData?.postCode === ""
                    ) {
                        check = true;
                        msg = t("message.field_validate_empty") + t("page.pretype." + fItem?.name);
                    }
                } else if (fItem?.name !== "channelStore" && fItem?.name !== "address") {
                    //@ts-ignore
                    if (ans[fItem?.name] === "" && fItem?.isRequired) {
                        check = true;
                        msg = t("message.field_validate_empty") + t("page.pretype." + fItem?.name);
                    }
                }
            });
            if (check) {
                warning(msg);
            } else {
                let outFull = "";
                let outF = "";
                let outL = "";
                if (isFullName) {
                    outFull = ans.fullName;
                    let nameSplit = ans.fullName.split(" ");
                    outF = nameSplit[0];
                    outL = nameSplit?.[1] || "";
                } else {
                    outF = ans.fName;
                    outL = ans.lName;
                    outFull = ans.fName + " " + ans.lName;
                }
                let payload = {
                    fullName: outFull,
                    firstName: outF,
                    lastName: outL,
                    acceptTermsAndConditions: ans.acceptTermsAndConditions,
                    ...(dateForm && { dateOfBirth: dateForm }),
                    ...(ans.email && { email: ans.email }),
                    ...(ans.gender && { gender: ans.gender }),
                    ...(ans.staffArea && { staffArea: ans.staffArea }),
                    memberTypeQuestion: outAnsList,
                    address: {
                        ...addressData,
                        subDistrict: addressData.subDistrict !== "" ? addressData.subDistrict : "",
                    },
                    ...(ans.id_card && { id_card: ans.id_card }),
                    ...(ans.companyName && { companyName: ans.companyName }),
                    ...(ans.studentID && { studentId: ans.studentID }),
                    ...(ans.staffID && { staffId: ans.staffID }),
                    // ...(ans.channelStore && { channelStore: ans.channelStore }),
                    inviteId: inviteCode || "",
                    sellerId: sellerCode || "",
                    couponId: couponId || "",
                    freepointId: freepointId || "",
                    fullAddress: fullAdd,
                    memberTypeGroupNameId: groupList[onSelect.groupIndex]?._id,
                    memberTypeNameId:
                        groupList[onSelect.groupIndex]?.typeGroupNameList[onSelect?.typeIndex]?._id,
                };
                // gId: groupList[onSelect.groupIndex]?._id,
                // tId: groupList[onSelect?.groupIndex]?.typeGroupNameList[onSelect?.typeIndex]?._id,
                await authApi.createMemberPreType(payload);
                setFormCompleted(true);
                success(t("message.sign_up.success"));
                dispatch(setExternalLogin({ type: enumExternalMethod.TEL, isSignUp: false }));
                await dispatch(getInfo());
                // window.location.reload();
                dispatch(setFromSignup(true));
                dispatch(setFromLogin(true));
                dispatch(setCouponId(""));
                dispatch(setInviteId(""));
                dispatch(setFreePointId(""));
                dispatch(
                    setMemberTypeDetail({
                        gId: groupList[onSelect.groupIndex]?._id,
                        tId: groupList[onSelect.groupIndex]?.typeGroupNameList[onSelect?.typeIndex]
                            ?._id,
                    })
                );
                history.push(PATH_HOME);
            }
        } catch (errors: any) {
            // const errorsResponse = errors.response.data.errors;
            if (errors.response) {
                error(formatMessage(errors.response));
            } else {
                console.error(errors);
                error(t("message.sign_up.fail"));
            }
            setIsLoaderActive(false);
        } finally {
            dispatch(setLoading(false));
            setIsLoaderActive(false);
        }
    };

    const days: ISelect[] = DAYS?.map((item) => {
        return {
            id: item,
            label: item,
        };
    });
    const months: ISelect[] = MONTHS?.map((item) => {
        return {
            id: item,
            label: item,
        };
    });
    const years: ISelect[] = YEARS?.map((item) => {
        return {
            id: item,
            label: item,
        };
    });

    const handleChangeDay = (value: string) => {
        setDate({
            ...date,
            day: value,
            error: "",
        });
    };
    const handleChangeMonth = (value: string) => {
        setDate({
            ...date,
            month: value,
            error: "",
        });
    };
    const handleChangeYear = (value: string) => {
        setDate({
            ...date,
            year: value,
            error: "",
        });
    };

    const onChangeGender = (value: string) => {
        let ansArr = { ...ans };
        ansArr.gender = value;
        setAns({ ...ansArr });
    };

    const changeAns = (e: any) => {
        let ansList = { ...ans };
        //@ts-ignore
        ansList[e.target.name] = e.target.value;
        setAns({ ...ansList });
    };

    const handleAnswerText = (value: any, fIndex: number) => {
        let gList = customField;
        gList[fIndex].answer = value;
        setCustomField([...gList]);
    };

    const handleChangeAnswerByIndex = (answer: string | string[], fIndex: number) => {
        let outAns: any = "";
        if (Array.isArray(answer)) {
            outAns = answer;
        } else {
            outAns = [answer];
        }
        let gList = customField;
        gList[fIndex].answer = outAns;
        setCustomField([...gList]);
    };

    const handleChangeTerm = (e: boolean) => {
        setIsTerm(!isTerm);
    };
    const handleTerms = () => {
        setIsTerm(!isTerm);
        let ansList = ans;
        ansList.acceptTermsAndConditions = true;
        setAns({ ...ansList });
    };

    const changeCheckBox = () => {
        let ansList = ans;
        ansList.acceptTermsAndConditions = !ans.acceptTermsAndConditions;
        setAns({ ...ansList });
    };

    const loadingComponent = (
        <StyledSkeleton>
            <div className="title-skeleton-rows">
                <Skeleton
                    loading={isLoading}
                    active
                    title={false}
                    paragraph={{ rows: 1, width: 63 }}
                ></Skeleton>
            </div>
            <div className="content-skeleton-rows">
                <Skeleton
                    loading={isLoading}
                    avatar
                    active
                    title={true}
                    paragraph={false}
                ></Skeleton>
                <Skeleton
                    loading={isLoading}
                    avatar
                    active
                    title={true}
                    paragraph={false}
                ></Skeleton>
                <Skeleton
                    loading={isLoading}
                    avatar
                    active
                    title={true}
                    paragraph={false}
                ></Skeleton>
                <Skeleton
                    loading={isLoading}
                    avatar
                    active
                    title={true}
                    paragraph={false}
                ></Skeleton>
                <Skeleton
                    loading={isLoading}
                    avatar
                    active
                    title={true}
                    paragraph={false}
                ></Skeleton>
            </div>

            <div className="title-skeleton-rows">
                <Skeleton
                    loading={isLoading}
                    active
                    title={false}
                    paragraph={{ rows: 1, width: 63 }}
                ></Skeleton>
            </div>
            <div className="content-skeleton-rows">
                <Skeleton
                    loading={isLoading}
                    avatar
                    active
                    title={true}
                    paragraph={false}
                ></Skeleton>
                <Skeleton
                    loading={isLoading}
                    avatar
                    active
                    title={true}
                    paragraph={false}
                ></Skeleton>
            </div>
        </StyledSkeleton>
    );

    return (
        <LoadingOverlay active={isLoaderActive} spinner text="Loading...">
            <StyledContainer mainColor={themes?.themeColor!} showTerm={false}>
                {step === 1 && (
                    <StyledType themeColor={themes?.themeColor!}>
                        <div className="top-detail">
                            <div className="layout-logo">
                                <img src={merchant?.themes?.logoSmallUrl} alt="" />
                            </div>
                        </div>
                        <h1>{t("page.member_type.pre_title")}</h1>
                        {isLoading === false ? (
                            <>
                                {groupList?.map((gItem: any, gIndex: number) => {
                                    return (
                                        <div key={gIndex} className="group-section">
                                            <p className="group-name">{gItem?.typeGroupName}</p>
                                            <div className="type-section">
                                                {gItem?.typeGroupNameList?.map(
                                                    (tItem: any, tIndex: number) => {
                                                        return (
                                                            <div
                                                                className={
                                                                    `type-item ` +
                                                                    (onSelect?.groupIndex ===
                                                                        gIndex &&
                                                                    onSelect?.typeIndex === tIndex
                                                                        ? "selected"
                                                                        : "")
                                                                }
                                                                key={tIndex}
                                                                onClick={() => {
                                                                    onSelecting(gIndex, tIndex);
                                                                    setType(tItem?.typeName);
                                                                }}
                                                            >
                                                                <img src={tItem?.typeNameIcon} />
                                                                <p>{tItem?.typeName}</p>
                                                            </div>
                                                        );
                                                    }
                                                )}
                                            </div>
                                        </div>
                                    );
                                })}
                            </>
                        ) : (
                            loadingComponent
                        )}

                        <div className="btn-skeleton-fullrow">
                            <Skeleton
                                loading={isLoading}
                                active
                                title={false}
                                paragraph={{ rows: 1 }}
                            >
                                <LoadOverlay active={true} radius={20}>
                                    <ButtonSubmit
                                        themeColor={themes?.themeColor!}
                                        onClick={step1Next}
                                    >
                                        {t("page.next")}
                                    </ButtonSubmit>
                                </LoadOverlay>
                            </Skeleton>
                        </div>
                    </StyledType>
                )}
                {step === 2 && (
                    <StyledStep2 themeColor={themes?.themeColor!}>
                        {/* <div className="top-detail">
                            <div className="layout-logo">
                                <img src={merchant?.themes?.logoSmallUrl} alt="" />
                            </div>
                        </div> */}
                        {/* <p>test</p> */}
                        <div className="logo-image">
                            <Skeleton
                                loading={isLoading}
                                avatar
                                active
                                title={false}
                                paragraph={false}
                            >
                                {<img src={merchant?.themes?.logoSmallUrl} />}
                            </Skeleton>
                        </div>
                        <div className="title_auth text-sub-header">
                            <Skeleton
                                loading={isLoading}
                                active
                                title={false}
                                paragraph={{ rows: 1, width: 132 }}
                            >
                                {t("page.createaccount_form")}
                            </Skeleton>
                        </div>
                        {type !== "" && <div className="title-type">({type})</div>}

                        {isFullName ? (
                            <div>
                                {/* <p className="custom-title-input">
                                {t("page.name_surname")}
                                <span style={{ color: "red" }}> * </span>
                            </p> */}
                                <SharedInput
                                    placeholder={t("page.name_surname")}
                                    name="fullName"
                                    // onChange={changeAns}
                                    onChange={(e: React.ChangeEvent<HTMLInputElement>) => {
                                        //cut double space
                                        e.target.value = e.target.value.replace(/\s{2,}/g, " ");
                                        e.target.value = e.target.value.replace(/\./g, "");
                                        changeAns(e);
                                    }}
                                    value={ans.fullName}
                                    style={{ marginBottom: "25px" }}
                                />
                            </div>
                        ) : (
                            <div>
                                <SharedInput
                                    placeholder={t("page.name")}
                                    name="fName"
                                    onChange={changeAns}
                                    value={ans.fName}
                                    style={{ marginBottom: "25px" }}
                                />
                                <SharedInput
                                    placeholder={t("page.surname")}
                                    name="lName"
                                    onChange={changeAns}
                                    value={ans.lName}
                                    style={{ marginBottom: "25px" }}
                                />
                            </div>
                        )}
                        {focusType?.typeNameSignForm?.map((fItem: any, fIndex: number) => {
                            if (fItem?.name === "channelStore") {
                                return;
                            }
                            if (
                                fItem?.name === "email" &&
                                fItem?.isActive &&
                                validateKey === enumValidateKey.EMAIL
                            ) {
                                {
                                    return (
                                        <div style={{ marginBottom: "25px" }}>
                                            <Row gutter={8}>
                                                <Col span={18}>
                                                    <SharedInput
                                                        placeholder={
                                                            fItem?.isRequired
                                                                ? "*" + t("page.email")
                                                                : t("page.email")
                                                        }
                                                        name="email"
                                                        value={ans.email}
                                                        onChange={changeAns}
                                                    />
                                                </Col>
                                                <Col span={6}>
                                                    <Button
                                                        className="buttonVerify"
                                                        onClick={checkValidateKey}
                                                    >
                                                        {t("page.verify")}
                                                    </Button>
                                                </Col>
                                            </Row>
                                        </div>
                                    );
                                }
                            } else if (
                                fItem?.name === "studentID" &&
                                fItem?.isActive &&
                                validateKey === enumValidateKey.STUDENT_ID
                            ) {
                                {
                                    return (
                                        <div style={{ marginBottom: "25px" }}>
                                            <Row gutter={8}>
                                                <Col span={18}>
                                                    <SharedInput
                                                        placeholder={t(
                                                            "page.pretype." + fItem?.name
                                                        )}
                                                        value={ans.studentID}
                                                        name={fItem?.name}
                                                        onChange={changeAns}
                                                    />
                                                </Col>
                                                <Col span={6}>
                                                    <Button
                                                        className="buttonVerify"
                                                        onClick={checkValidateKey}
                                                    >
                                                        {t("page.verify")}
                                                    </Button>
                                                </Col>
                                            </Row>
                                        </div>
                                    );
                                }
                            } else if (
                                fItem?.name === "nationalID" &&
                                fItem?.isActive &&
                                validateKey === enumValidateKey.NATIONAL_ID
                            ) {
                                {
                                    return (
                                        <div style={{ marginBottom: "25px" }}>
                                            <Row gutter={8}>
                                                <Col span={18}>
                                                    <SharedInput
                                                        placeholder={t(
                                                            "page.pretype." + fItem?.name
                                                        )}
                                                        value={ans.nationalID}
                                                        name={fItem?.name}
                                                        onChange={changeAns}
                                                    />
                                                </Col>
                                                <Col span={6}>
                                                    <Button
                                                        className="buttonVerify"
                                                        onClick={checkValidateKey}
                                                    >
                                                        {t("page.verify")}
                                                    </Button>
                                                </Col>
                                            </Row>
                                        </div>
                                    );
                                }
                            } else if (
                                fItem?.name === "staffID" &&
                                fItem?.isActive &&
                                validateKey === enumValidateKey.STAFF_ID
                            ) {
                                {
                                    return (
                                        <div style={{ marginBottom: "25px" }}>
                                            <Row gutter={8}>
                                                <Col span={18}>
                                                    <SharedInput
                                                        placeholder={t(
                                                            "page.pretype." + fItem?.name
                                                        )}
                                                        value={ans.staffID}
                                                        name={fItem?.name}
                                                        onChange={changeAns}
                                                    />
                                                </Col>
                                                <Col span={6}>
                                                    <Button
                                                        className="buttonVerify"
                                                        onClick={checkValidateKey}
                                                    >
                                                        {t("page.verify")}
                                                    </Button>
                                                </Col>
                                            </Row>
                                        </div>
                                    );
                                }
                            } else if (fItem?.name === "id_card" && fItem?.isActive) {
                                return (
                                    <SharedInput
                                        placeholder={
                                            staticQuestion?.id_card?.isRequired
                                                ? "*" + t("page.cardId")
                                                : t("page.cardId")
                                        }
                                        name="id_card"
                                        style={{ marginBottom: "16px" }}
                                        onChange={changeAns}
                                        value={ans.id_card}
                                        length={13}
                                    />
                                );
                            } else if (fItem?.name === "dateOfBirth" && fItem?.isActive) {
                                return (
                                    <div key={fIndex} style={{ marginTop: "0" }}>
                                        {/* <p className="custom-title-input">
                                            {t("page.pretype.dateOfBirth")}
                                            {fItem?.isRequired && (
                                                <span style={{ color: "red" }}> * </span>
                                            )}
                                        </p> */}
                                        <div className="day">
                                            <Row gutter={16}>
                                                <Col span={8}>
                                                    <DynamicDropdown
                                                        setValue={date.day || undefined}
                                                        value="id"
                                                        label="label"
                                                        options={days}
                                                        handleChange={handleChangeDay}
                                                        placeholder={
                                                            staticQuestion?.dateOfBirth?.isRequired
                                                                ? "*" + t("page.day")
                                                                : t("page.day")
                                                        }
                                                    />
                                                </Col>
                                                <Col span={8}>
                                                    <DynamicDropdown
                                                        setValue={date.month || undefined}
                                                        value="id"
                                                        label="label"
                                                        options={months}
                                                        handleChange={handleChangeMonth}
                                                        placeholder={
                                                            staticQuestion?.dateOfBirth?.isRequired
                                                                ? "*" + t("page.month")
                                                                : t("page.month")
                                                        }
                                                    />
                                                </Col>
                                                <Col span={8}>
                                                    <DynamicDropdown
                                                        setValue={date.year || undefined}
                                                        value="id"
                                                        label="label"
                                                        options={years}
                                                        handleChange={handleChangeYear}
                                                        placeholder={
                                                            staticQuestion?.dateOfBirth?.isRequired
                                                                ? "*" + t("page.year")
                                                                : t("page.year")
                                                        }
                                                    />
                                                </Col>
                                            </Row>
                                            {date.error && (
                                                <StyledError visible={true}>
                                                    {t("validation.is_required")}{" "}
                                                </StyledError>
                                            )}
                                        </div>
                                    </div>
                                );
                            } else if (fItem?.name === "gender" && fItem?.isActive) {
                                return (
                                    <div key={fIndex} className="gender">
                                        {/* <p className="custom-title-input">
                                            {t("page.pretype.gender")}
                                            {fItem?.isRequired && (
                                                <span style={{ color: "red" }}> * </span>
                                            )}
                                        </p> */}
                                        <Radio.Group
                                            onChange={(e) => onChangeGender(e.target.value)}
                                            value={ans.gender}
                                            style={{
                                                width: "100%",
                                                padding: "0 12px",
                                                marginBottom: "13px",
                                            }}
                                        >
                                            <Row gutter={16}>
                                                <Flex
                                                    align="center"
                                                    justify="space-evenly"
                                                    style={{ width: "100%" }}
                                                >
                                                    {genderOptions.map((option, index) => (
                                                        <Flex key={index} flex={"1"}>
                                                            <Radio
                                                                key={option.id}
                                                                value={option.id}
                                                            >
                                                                {t(`page.${option.id}`)}
                                                            </Radio>
                                                        </Flex>
                                                    ))}
                                                </Flex>
                                            </Row>
                                        </Radio.Group>
                                    </div>
                                );
                            } else if (
                                fItem?.name === "address" &&
                                !merchant?.signUpSettings?.staticQuestion?.address?.isRedeem
                            ) {
                                return (
                                    <StyledSurvey mainColor={themes?.themeColor!} key={fIndex}>
                                        <div style={{ marginBottom: "0px" }}>
                                            <p className="custom-title-input">
                                                {staticQuestion?.address?.isRequired
                                                    ? "*" + t("page.address")
                                                    : t("page.address")}
                                                {merchant?.signUpSettings?.staticQuestion?.address
                                                    ?.isRequired && (
                                                    <span style={{ color: "red" }}> * </span>
                                                )}
                                            </p>
                                            <SharedInput
                                                name="freeTextAnswer"
                                                value={addressData?.address}
                                                onChange={(e: React.ChangeEvent<HTMLFormElement>) =>
                                                    setAddressText(e.target.value, "address")
                                                }
                                                styleParent={{
                                                    height: "48px",
                                                    // marginBottom: "25px",
                                                }}
                                                style={{
                                                    backgroundColor: "white",
                                                    border: "1px solid gray",
                                                }}
                                            />
                                            <Flex gap={8}>
                                                <Flex flex={1} vertical>
                                                    <p className="input-title ">
                                                        {t("page.province")}
                                                        {merchant?.signUpSettings?.staticQuestion
                                                            ?.address?.isRequired && (
                                                            <span style={{ color: "red" }}>
                                                                {" "}
                                                                *{" "}
                                                            </span>
                                                        )}
                                                    </p>
                                                    <DynamicDropdown
                                                        value="province_id"
                                                        label="province_name_tha"
                                                        options={provinceList}
                                                        placeholder={t("page.province")}
                                                        handleChange={onChangeProvince}
                                                    />
                                                </Flex>

                                                <Flex flex={1} vertical>
                                                    <p className="input-title ">
                                                        {t("page.county")}
                                                        {merchant?.signUpSettings?.staticQuestion
                                                            ?.address?.isRequired && (
                                                            <span style={{ color: "red" }}>
                                                                {" "}
                                                                *{" "}
                                                            </span>
                                                        )}
                                                    </p>
                                                    <DynamicDropdown
                                                        value="amphur_id"
                                                        label="amphur_name_tha"
                                                        options={amphurList}
                                                        placeholder={t("page.county")}
                                                        handleChange={onChangeAmphur}
                                                    />
                                                </Flex>
                                            </Flex>

                                            <Flex gap={8}>
                                                <Flex flex={1} vertical>
                                                    <p className="input-title ">
                                                        {t("page.district")}
                                                        {merchant?.signUpSettings?.staticQuestion
                                                            ?.address?.isRequired && (
                                                            <span style={{ color: "red" }}>
                                                                {" "}
                                                                *{" "}
                                                            </span>
                                                        )}
                                                    </p>

                                                    <DynamicDropdown
                                                        value="district_id"
                                                        label="district_name_tha"
                                                        options={subDistrictList}
                                                        placeholder={t("page.district")}
                                                        handleChange={onChangeSubDistrict}
                                                    />
                                                </Flex>

                                                <Flex flex={1} vertical>
                                                    <p className="input-title ">
                                                        {t("page.zipcode")}
                                                        {merchant?.signUpSettings?.staticQuestion
                                                            ?.address?.isRequired && (
                                                            <span style={{ color: "red" }}>
                                                                {" "}
                                                                *{" "}
                                                            </span>
                                                        )}
                                                    </p>

                                                    <SharedInput
                                                        name="freeTextAnswer"
                                                        value={addressData?.postCode}
                                                        onChange={(
                                                            e: React.ChangeEvent<HTMLFormElement>
                                                        ) =>
                                                            setAddressText(
                                                                e.target.value,
                                                                "postCode"
                                                            )
                                                        }
                                                        styleParent={{
                                                            height: "48px",
                                                            marginBottom: "25px",
                                                        }}
                                                        style={{
                                                            backgroundColor: "white",
                                                            border: "1px solid gray",
                                                        }}
                                                    />
                                                </Flex>
                                            </Flex>
                                        </div>
                                    </StyledSurvey>
                                );
                            } else {
                                if (fItem?.isActive && fItem?.name !== "address") {
                                    return (
                                        <div key={fIndex}>
                                            {/* <p className="custom-title-input">
                                                {fItem?.isRequired && (
                                                    <span style={{ color: "red" }}> * </span>
                                                )}
                                            </p> */}
                                            <SharedInput
                                                placeholder={t("page.pretype." + fItem?.name)}
                                                //@ts-ignore
                                                value={ans[fItem?.name]}
                                                name={fItem?.name}
                                                onChange={changeAns}
                                                style={{ marginBottom: "25px" }}
                                            />
                                        </div>
                                    );
                                }
                            }
                        })}
                        {customField?.map((fItem: any, fIndex: number) => {
                            return (
                                <div
                                    className="custom-title-input"
                                    style={{ marginTop: fIndex === 0 ? "0px" : "" }}
                                    key={fIndex}
                                >
                                    {/* <p
                                        className={
                                            "custom-title-input input-title " +
                                            `${
                                                fItem?.multiple &&
                                                "multiple-title custom-title-input"
                                            }`
                                        }
                                    >
                                        {fItem.question}
                                        {fItem?.isRequired && (
                                            <span style={{ color: "red" }}> * </span>
                                        )}
                                    </p> */}

                                    {fItem?.isFreeTextAnswer === true && (
                                        <>
                                            <SharedInput
                                                placeholder={
                                                    fItem.displayName
                                                        ? fItem.displayName
                                                        : fItem.question
                                                }
                                                name="freeTextAnswer"
                                                value={
                                                    Object.keys(fItem?.answer).length <= 0
                                                        ? ""
                                                        : fItem?.answer
                                                }
                                                onChange={(
                                                    e: React.ChangeEvent<HTMLFormElement>
                                                ) => {
                                                    handleAnswerText(e.target.value, fIndex);
                                                }}
                                                styleParent={{ height: "48px" }}
                                                style={{
                                                    backgroundColor: "white",
                                                    lineHeight: "27px",
                                                    // border: "1px solid gray",
                                                }}
                                            />
                                        </>
                                    )}

                                    {fItem?.isFreeTextAnswer === false && (
                                        <Select
                                            showSearch
                                            placeholder={
                                                fItem.fieldName ? fItem.fieldName : fItem.question
                                            }
                                            value={fItem?.answer}
                                            onChange={(value: string[]) => {
                                                handleChangeAnswerByIndex(value, fIndex);
                                            }}
                                            mode={fItem.multiple ? "multiple" : undefined}
                                            // showArrow={true}
                                            // open={true}
                                        >
                                            {fItem?.options?.map((option: any) => {
                                                return (
                                                    <Option
                                                        key={option.optionName}
                                                        value={option.optionName}
                                                    >
                                                        {option.optionName}
                                                    </Option>
                                                );
                                            })}
                                        </Select>
                                    )}
                                </div>
                            );
                        })}
                        {isTerm && (
                            <ComponentPopUpTerms
                                data={terms}
                                handleConfirm={handleTerms}
                                showTerm={isTerm}
                            />
                        )}
                        <div className="term-field">
                            <StyledCheck color={themes?.themeColor!}>
                                <Checkbox
                                    name="acceptTermsAndConditions"
                                    checked={ans.acceptTermsAndConditions}
                                    onClick={changeCheckBox}
                                    // label={<span>{t("page.accept")} </span>}
                                >
                                    <span>{t("page.accept")} </span>
                                </Checkbox>
                            </StyledCheck>
                            <span
                                style={{ textDecoration: "underline", cursor: "pointer" }}
                                onClick={() => handleChangeTerm(true)}
                            >
                                {t("page._terms_and_conditions")}
                            </span>
                        </div>

                        <LoadOverlay active={true} radius={20}>
                            <>
                                <ButtonSubmit
                                    themeColor={themes?.themeColor!}
                                    onClick={() => {
                                        step2Next();
                                    }}
                                >
                                    {t("page.createaccount")}
                                </ButtonSubmit>
                            </>
                        </LoadOverlay>
                    </StyledStep2>
                )}
            </StyledContainer>
        </LoadingOverlay>
    );
};

//#region STYLES

const StyledSkeleton = styled.div`
    .title-skeleton-rows {
        .ant-skeleton {
            .ant-skeleton-paragraph {
                li {
                    height: 10px;
                    border-radius: 16px;
                }
            }
        }
    }
    .content-skeleton-rows {
        display: grid;
        grid-template-columns: 1fr 1fr 1fr;
        gap: 12px;
        padding: 12px;
        .ant-skeleton {
            display: flex;
            width: 100%;
            flex-direction: column;
            margin-bottom: 15px;
            align-items: center;
            .ant-skeleton-header {
                padding-right: 0;
                span {
                    width: 82px !important;
                    height: 82px;
                    border-radius: 14px;
                }
            }
            .ant-skeleton-title {
                width: 63px !important;
                height: 10px;
                border-radius: 4px;
                margin: 0 auto;
                margin-top: 15px;
            }
            .ant-skeleton-paragraph {
                margin-top: 0 !important;
                li {
                    height: 10px;
                    border-radius: 4px;
                    &:last-child {
                        margin-top: 15px;
                    }
                }
            }
        }
    }
`;

const StyledType = styled.div<{ themeColor: string }>`
    background-color: #fff;
    .btn-skeleton-fullrow {
        .ant-skeleton {
            .ant-skeleton-paragraph {
                margin-top: 0 !important;
                li {
                    height: 52px;
                    border-radius: 16px;
                    width: 100% !important;
                }
            }
        }
    }
    h1 {
        font-size: 29px;
        line-height: 36px;
        font-weight: 600;
        margin-bottom: 32px;
    }
    padding: 20px;
    .top-detail {
        margin-bottom: 20px;
        position: absolute;
        right: 20px;
        .layout-logo {
            text-align: right;
            img {
                width: 42px;
                height: 42px;
                object-fit: cover;
                border-radius: 100%;
            }
        }
    }
    .group-section {
        margin-bottom: 15px;
        .group-name {
            color: ${(p) => p.themeColor};
            font-size: 20px;
            font-weight: 600;
            margin-bottom: 10px;
        }
        .type-section {
            display: grid;
            grid-template-columns: 1fr 1fr 1fr;
            grid-gap: 10px;
            text-align: left;
            padding-bottom: 30px;
            .type-item {
                cursor: pointer;
                font-weight: 600;
                height: auto;
                img {
                    width: 100%;
                    height: 120px;
                    object-fit: cover;
                    border-radius: 30px;
                    border: 2px solid transparent;
                    /* margin-bottom: 10px; */
                    // padding: 10px;
                }
                p {
                    font-size: 14px;
                    line-height: 23px;
                    text-align: center;
                    font-weight: 500;
                    margin-bottom: 5px;
                    display: -webkit-box;
                    -webkit-line-clamp: 2;
                    -webkit-box-orient: vertical;
                    overflow: hidden;
                }
            }
            .selected {
                color: ${(p) => p.themeColor};
                img {
                    border: 2px solid ${(p) => p.themeColor};
                }
            }
        }
    }
    .next-btn {
        width: 100%;
        color: #fff;
        background-color: ${(p) => p.themeColor};
        height: 48px;
        border-radius: 50px;
    }
`;

const StyledStep2 = styled.div<{ themeColor: string }>`
    h1 {
        font-size: 32px;
        line-height: 36px;
        font-weight: 600;
        margin-bottom: 32px;
    }
    /* > div {
        margin-bottom: 8px;
    } */
    .buttonVerify {
        display: flex;
        height: 48px;
        width: 100%;
        padding: 14px 12px;
        justify-content: center;
        align-items: center;
        gap: 8px;
        border-radius: var(--12-px, 12px);
        border: 1px solid var(--Primary-linear, ${(p) => p.themeColor});
        background-color: white;
        color: ${(p) => p.themeColor};
    }
    padding: 20px;
    .title_auth {
        text-align: center;
        .ant-skeleton {
            .ant-skeleton-paragraph {
                li {
                    margin: 0 auto;
                    height: 10px;
                    border-radius: 16px;
                    margin-bottom: 12px;
                }
            }
        }
    }
    .title-type {
        color: #9b9b9b;
        font-size: 15px;
        line-height: 18px;
        margin-bottom: 20px;
        text-align: center;
        font-weight: 500;
    }
    .logo-image {
        width: 120px;
        align-items: center;
        margin: auto;
        margin-bottom: 10px;
        img {
            width: 120px;
            height: auto;
            border-radius: 60px;
        }
        .ant-skeleton {
            .ant-skeleton-header {
                padding-right: 0;
                span {
                    width: 120px !important;
                    height: 120px;
                    margin-bottom: 15px;
                }
            }
        }
    }
    .top-detail {
        margin-bottom: 20px;
        .layout-logo {
            text-align: right;
            img {
                width: 42px;
                height: 42px;
                object-fit: cover;
                border-radius: 100%;
            }
        }
    }
    .ant-select-selection {
        box-shadow: none !important;
        height: 48px;
        font-size: 14px;
        color: inherit;
        display: flex;
        flex-direction: column;
        justify-content: center;
        border-radius: 6px;
        background-color: #fff;
        border: 1px solid #dadada !important;
        cursor: default;
        width: 100%;
    }
    .date-select {
        width: 100%;
        height: 48px;
    }
    .gender-select {
        width: 100%;
        height: 48px;
    }
    .address-select {
        width: 100%;
        height: 48px;
    }
    .term-field {
        display: flex;
        justify-content: flex-start;
        align-items: center;
        margin: 20px 0;
        font-size: 13px;
    }
    .next-btn {
        width: 100%;
        color: #fff;
        background-color: ${(p) => p.themeColor};
        height: 48px;
        border-radius: 50px;
    }

    .custom-title-input {
        margin: 12px 0 6 0;
        color: #919191;
        font-size: 16px;
        font-weight: 500;
        margin-top: 26px;
        .ant-select {
            width: 100%;
        }
    }
`;

const ButtonSubmit = styled.button<{ themeColor: string }>`
    width: 100%;
    background-color: ${(p) => p.themeColor};
    border: none;
    color: #fff;
    height: 48px;
    border-radius: 50px;
    display: flex;
    justify-content: center;
    align-items: center;
    font-weight: 600;
    /* &:hover {
            background-color: ${(p) => p.themeColor};
            border:none;
            color: #fff;
        } */
`;

const StyledSurvey = styled.div<{ mainColor: string }>`
    /* padding: 20px ; */
    .ant-select-selection {
        box-shadow: none !important;
        height: 48px;
        font-size: 14px;
        color: inherit;
        display: flex;
        flex-direction: column;
        justify-content: center;
        border-radius: 6px;
        background-color: #fff;
        border: 1px solid #dadada !important;
        cursor: default;
        width: 100%;
    }
    .intl-tel-input input {
        border-radius: 6px;
    }
    .btn-section {
        display: grid;
        grid-template-columns: 1fr 1fr;
        grid-gap: 20px;
        .btn {
            width: 100%;
            height: 55px;
            border-radius: 500px;
            font-size: 16px;
        }
        .back {
            color: #f22f46;
            background-color: #fff;
            border: 1px solid #f22f46;
        }
        .save {
            //
            background-color: #f22f46;
            color: white;
        }
    }
    .input-title {
        margin: 12px 0 8px 0;
        color: #919191;
        font-size: 16px;
        font-weight: 500;
    }
    .multiple-title {
        margin-bottom: 10px;
        line-height: 16px;
    }
    .ant-select-selection--multiple {
        .ant-select-arrow {
            margin-top: 0px;
        }
    }
`;

const StyledCheck = styled.div<{ color: string }>`
    .ant-checkbox-checked {
        .ant-checkbox-inner {
            background-color: ${(p) => p.color} !important;
            border-color: ${(p) => p.color} !important;
        }
    }
`;

const StyledContainer = styled.div<{ showTerm: boolean; mainColor: string }>`
    position: relative;
    padding: 11px;
    background-color: #fff;
    color: #676767;
    text-align: start;
    font-weight: normal;
    font-size: 20px;
    line-height: 27px;
    .day {
        margin-bottom: 27px;
        border-radius: 6px;
        .title {
            font-size: 16px;
            color: #676767;
        }
    }
    .gender,
    .email {
        border-radius: 6px;
        .title {
            font-size: 16px;
            color: #676767;
        }
        .ant-radio-checked {
            .ant-radio-inner {
                border-color: ${(p) => p.mainColor};
                background-color: ${(p) => p.mainColor};
            }
        }
    }
    .bottom {
        width: fit-content;
        margin: 0 auto;
        margin-top: 5rem;
        text-align: center;
        span {
            font-weight: normal;
            font-size: 16px;
            line-height: 21px;
            color: #676767;
        }
        /* .ant-checkbox-wrapper {
        display: block;
    } */
    }
    .ant-select {
        width: 100%;
    }
    .ant-select-selection {
        /* border-color: gray !important; */
        box-shadow: none !important;
        height: 48px;
        font-size: 16px;
        color: inherit;
        display: flex;
        flex-direction: column;
        justify-content: center;
        background-color: #fff;
        border-radius: 6px;
        border: 1px solid lightgray;
    }
    input {
        background-color: white !important;
        border: 1px solid lightgray;
    }

    input[type="search"] {
        background-color: transparent !important;
    }

    .selected-dial-code {
        padding-left: 0 !important;
    }
    .selected-flag {
        display: flex !important;
    }
    .intl-tel-input .country-list {
        width: 100%;
    }
    .intl-tel-input input {
        border-radius: 6px;
    }
    .term-field {
        display: flex;
        justify-content: center;
    }
    .term-condition {
        display: ${(p) => (p.showTerm ? "unset;" : "none;")};
        width: 100%;
        height: 100%;
        /* background-color: white; */
        background-color: ${(p) => p.theme.colors.card};
        position: absolute;
        top: 0;
        left: 0;
        font-size: 14px;
        overflow: auto;
        z-index: 100;
        ::-webkit-scrollbar {
            display: none;
        }
    }

    .ant-select-arrow {
        color: ${(p) => p.mainColor} !important;

        stroke-width: 50px;
        stroke: ${(p) => p.mainColor};
    }

    .ant-checkbox-inner {
        border-color: ${(p) => p.mainColor};
    }
    :hover .ant-checkbox-checked:not(.ant-checkbox-disabled) .ant-checkbox-inner {
        background-color: ${(p) => p.mainColor} !important;
    }
    :not(.ant-checkbox-wrapper-disabled):hover .ant-checkbox-inner,
    :where(.css-dev-only-do-not-override-1kuana8).ant-checkbox:not(.ant-checkbox-disabled):hover
        .ant-checkbox-inner {
        border-color: ${(p) => p.mainColor};
    }
`;

//#endregion
